import numeral from 'numeral'

let ybLineItemMixin = {
	methods: {
		format: function (value, format) {
			return numeral(value).format(format)
		}
	},
	computed: {
		isBulk: function () {
			return (this.record.fieldData['NDC Number'] && this.record.fieldData['NDC Number'].includes('**'))/* || (this.modelRecord && this.modelRecord['NDC Number'] && this.modelRecord['NDC Number'].currentValue)*/
		},
		hasFactor: function () {
			return this.record.fieldData['hcn.holding_li_SHOWCN_danox_dic::Bulk Raw Liquid LU::factor'] > 0
		},
		percentFill: function () {
			return this.format(this.record.fieldData['Percent Fill'], '0.00%')
		},
		showUnitConverter: function () {
			return this.record.fieldData['hcn.holding_li_SHOWCN_danox_dic__finalCode::Avg. Tablet'] === 'Yes'/* && (this.record.fieldData['hcn.holding_li_SHOWCN_danox_dic__finalCode::Package Size Density'] && this.record.fieldData['hcn.holding_li_SHOWCN_danox_dic__finalCode::Package Size Density'].length > 0)*/
		},
		showStageUnitConverter: function () {
			return this.record.fieldData['hcn.holding_li_SHOWCN_danox_dic::HasStages']
			/*let stages = this.record.fieldData['hcn.holding_li_SHOWCN_danox_dic__finalCode::Avg. Tablet Stages'] === 'Yes';
			let ndcFirstFive = this.record.fieldData['NDC Number'] && this.record.fieldData['NDC Number'].substring(0, 5);
			let labelerCodes = this.record.fieldData['Labeler Codes'];
			if (stages && labelerCodes && labelerCodes.includes(ndcFirstFive)) {
				return true
			}*/
		},
	}
}

export default ybLineItemMixin